import $http from "../axios";

const state = {
  products: [],
  scaleProducts: []
};

const getters = {
  products: state => {
    return state.products;
  },
  scaleProducts: state => {
    return state.scaleProducts;
  }
};

const actions = {
  getProducts({ commit, getters }, storeId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`products?storeId=${storeId}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PRODUCTS", res.data.payload.products);
            if (getters.storeBeingManaged.address.countryCode === "PT") {
              commit(
                "SET_PRODUCTS_DEFAULT_VAT",
                getters.storeBeingManaged.taxes.defaultVAT
              );
            }
            commit("SET_SCALE_PRODUCTS", res.data.payload.scaleProducts);
            commit(
              "SET_SCALE_PRODUCTS_BASE",
              res.data.payload.scaleProductsBase,
              { root: true }
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getProductsForOrder({ commit, getters }, storeId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`products-for-order?storeId=${storeId}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PRODUCTS", res.data.payload.products);
            if (getters.storeBeingManaged.address.countryCode === "PT") {
              commit(
                "SET_PRODUCTS_DEFAULT_VAT",
                getters.storeBeingManaged.taxes.defaultVAT
              );
            }
            commit("SET_CATALOG_ID", res.data.payload.catalogId);
            // commit("SET_SCALE_PRODUCTS", res.data.payload.scaleProducts);
            // commit(
            //   "SET_SCALE_PRODUCTS_BASE",
            //   res.data.payload.scaleProductsBase,
            //   { root: true }
            // );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  searchProduct(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("search-product", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveProduct({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("save-product", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PRODUCT", data.product);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveProductsChanges(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("save-products-changes", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateScaleProductPrice({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-scale-product-price", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_SCALE_PRODUCT", data.product);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateIdealQty({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-ideal-qty", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PRODUCT_IDEAL_QTY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateCurrentQty({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-current-qty", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PRODUCT_CURRENT_QTY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateValidity({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-validity", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PRODUCT_VALIDITY", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  copyCatalog(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("copy-catalog", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteCatalog(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-catalog", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  bulkUpdateProducts(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("bulk-update-products", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removeProductFromCatalog({ commit }, barcode) {
    commit("REMOVE_PRODUCT_FROM_CATALOG", barcode);
  }
};

const mutations = {
  SET_PRODUCTS(state, products) {
    if (products && products.length) {
      state.products = products.map(p => {
        p.p /= 100;
        p.v = p.v ? new Date(p.v) : null;
        p.vp = p.vp ? p.vp / 100 : 0;
        return p;
      });
    } else {
      state.products = [];
    }
  },

  SET_SCALE_PRODUCTS(state, scaleProducts) {
    if (scaleProducts && scaleProducts.length) {
      state.scaleProducts = scaleProducts.map(p => {
        p.p /= 100;
        p.lc /= 100;
        return p;
      });
    } else {
      state.scaleProducts = [];
    }
  },

  SET_PRODUCTS_DEFAULT_VAT(state, defaultVAT) {
    for (let i = 0; i < state.products.length; i++) {
      if (isNaN(state.products[i].vat)) {
        state.products[i].vat = defaultVAT;
      }
    }
  },

  UPDATE_PRODUCT(state, product) {
    const index = state.products.findIndex(p => {
      return p.b === product.b;
    });
    if (index === -1) {
      product.p /= 100;
      product.vp = product.vp ? product.vp / 100 : 0;
      state.products.push(product);
    } else if (!product.p) {
      state.products.splice(index, 1);
    } else {
      state.products = state.products.map(p => {
        return p.b === product.b
          ? {
              ...product,
              p: product.p / 100,
              vp: product.vp ? product.vp / 100 : 0
            }
          : p;
      });
    }
  },

  UPDATE_SCALE_PRODUCT(state, product) {
    const index = state.scaleProducts.findIndex(p => {
      return p.code === product.code;
    });
    if (index === -1) {
      product.p /= 100;
      state.scaleProducts.push(product);
    } else if (!product.p) {
      state.scaleProducts.splice(index, 1);
    } else {
      state.scaleProducts = state.scaleProducts.map(p => {
        return p.code === product.code ? { ...product, p: product.p / 100 } : p;
      });
    }
  },

  UPDATE_PRODUCT_IDEAL_QTY(state, product) {
    const index = state.products.findIndex(p => {
      return p.b === product.b;
    });
    state.products[index].iq = product.iq;
  },

  UPDATE_PRODUCT_CURRENT_QTY(state, product) {
    const index = state.products.findIndex(p => {
      return p.b === product.b;
    });
    state.products[index].cq = product.cq;
  },

  UPDATE_PRODUCT_VALIDITY(state, product) {
    const index = state.products.findIndex(p => {
      return p.b === product.b;
    });
    state.products[index].v = product.v;
  },

  REMOVE_PRODUCT_FROM_CATALOG(state, barcode) {
    const index = state.products.findIndex(p => {
      return p.b === barcode;
    });
    state.products.splice(index, 1);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
